import { IStyles } from '../../../../../theme'

export const defaultNoDevicesTheme: IStyles = {
    step1: `images/no-devices/step-1.svg`,
    step2: `images/no-devices/step-2.svg`,
    step3: `images/no-devices/step-3.svg`,
    dark: `#303030`,
    light: `#B3B3B3`,
}
